import { render, staticRenderFns } from "./MpStageNormal.vue?vue&type=template&id=fa6b2f4e&scoped=true&"
import script from "./MpStageNormal.vue?vue&type=script&lang=js&"
export * from "./MpStageNormal.vue?vue&type=script&lang=js&"
import style0 from "./MpStageNormal.vue?vue&type=style&index=0&id=fa6b2f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6b2f4e",
  null
  
)

export default component.exports